import { createSlice } from "@reduxjs/toolkit";

// Get the initial speed unit from localStorage, or default to 'kph'
let initialSpeedUnit = "kph"; // default unit
let initialAircraftAltitudeFilter = 35000; // default altitude in ft
let initialAircraftDistanceFilter = 50; // default distance in mi
let initialMeasurementSystem = "Metric"; // default measurement system

if (typeof window !== "undefined") {
  // Ensure we're in a browser environment
  const savedSpeedUnit = localStorage.getItem("speedUnit");
  if (savedSpeedUnit) {
    initialSpeedUnit = savedSpeedUnit.toLowerCase(); // Ensure lowercase
    // Also set the measurement system based on speed unit
    initialMeasurementSystem = savedSpeedUnit === "mph" ? "Imperial" : "Metric";
  }

  const savedAltitudeFilter = localStorage.getItem("aircraftAltitudeFilter");
  if (savedAltitudeFilter) {
    initialAircraftAltitudeFilter = parseInt(savedAltitudeFilter);
  }

  const savedDistanceFilter = localStorage.getItem("aircraftDistanceFilter");
  if (savedDistanceFilter) {
    initialAircraftDistanceFilter = parseInt(savedDistanceFilter);
  }
}

const initialState = {
  speedUnit: initialSpeedUnit,
  measurementSystem: initialMeasurementSystem,
  aircraftAltitudeFilter: initialAircraftAltitudeFilter,
  aircraftDistanceFilter: initialAircraftDistanceFilter,
  // Other user settings can be added here
};

const trackerSlice = createSlice({
  name: "trackerSettings",
  initialState,
  reducers: {
    setSpeedUnit(state, action) {
      state.speedUnit = action.payload;
      // Also update the measurement system
      state.measurementSystem =
        action.payload === "mph" ? "Imperial" : "Metric";

      if (typeof window !== "undefined") {
        // Save the new speed unit to localStorage
        localStorage.setItem("speedUnit", action.payload);
      }
    },
    setMeasurementSystem(state, action) {
      state.measurementSystem = action.payload;
      // Also update the speed unit
      state.speedUnit = action.payload === "Imperial" ? "mph" : "kph";

      if (typeof window !== "undefined") {
        // Save the derived speed unit to localStorage
        localStorage.setItem("speedUnit", state.speedUnit);
      }
    },
    setAircraftAltitudeFilter(state, action) {
      state.aircraftAltitudeFilter = action.payload;
      if (typeof window !== "undefined") {
        localStorage.setItem(
          "aircraftAltitudeFilter",
          action.payload.toString()
        );
      }
    },
    setAircraftDistanceFilter(state, action) {
      state.aircraftDistanceFilter = action.payload;
      if (typeof window !== "undefined") {
        localStorage.setItem(
          "aircraftDistanceFilter",
          action.payload.toString()
        );
      }
    },
    // Add other reducers for different settings if needed
  },
});

export const {
  setSpeedUnit,
  setMeasurementSystem,
  setAircraftAltitudeFilter,
  setAircraftDistanceFilter,
} = trackerSlice.actions;

export default trackerSlice.reducer;
